import React from 'react'
import { Accordion } from '../components'
import { Inner, Item } from '../components/accordion/styles/accordion'
import faqsData from '../fixtures/faqs.json'

export function AccordionContainer() {
    return (
        <Accordion>
            <Accordion.Title>Frequently Asked Questions</Accordion.Title>
            {faqsData.map((item)=> (
                <Accordion.Item key={item.id}>
                    <Accordion.Header>{item.header}</Accordion.Header>
                    <Accordion.Body> {item.body} </Accordion.Body>
                </Accordion.Item>
            ))}
        </Accordion>
        
    )
}
